// import React from "react";
import { GetServerSideProps } from "next/types"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Page } from "types/page"
import { CertificateGenerator } from "@cs/screens/certificate"
import { useRouter } from "next/router"
import { fetchSkeleton } from "@cs/lib/firebase/courses/fetchChapter"
import { Course } from "@cs/lib/models/skeleton.model"
import { SSRConfig } from "next-i18next"
import { nestedLayout } from "layouts/nestedLayout"
import { progressLayout } from "layouts/Progress.layout"
import noFooterLayout from "layouts/NoFooter.layout"
import { CourseType } from "@cs/components/hooks/useCourseProgress"

interface CoursesPageProps extends SSRConfig {
  courses: Course[]
}

const CertificatePage: Page<CoursesPageProps> = ({ courses }) => {
  const router = useRouter()
  return (
    <main>
      <CertificateGenerator
        courseId={router.query.course?.toString() ?? ""}
        courses={courses}
        basic={(router.query.basic?.toString() as CourseType) ?? "Basics"}
      />
    </main>
  )
}

CertificatePage.getLayout = nestedLayout(progressLayout, noFooterLayout)

export default CertificatePage

export const getStaticProps: GetServerSideProps<CoursesPageProps> = async ({ locale }) => {
  const { skeleton, error } = await fetchSkeleton(locale ?? "en")
  if (error || !skeleton) {
    return {
      notFound: true,
    }
  }

  const courses = skeleton.ordered.map(element => element.courses).flat()

  return {
    props: {
      courses,
      ...(await serverSideTranslations(
        locale ?? "en",
        ["common", "footer", "nav", "certificate", "custom404", "landing-page"],
        nextI18nextConfig,
      )),
    },
  }
}
